<app-header></app-header>
<ion-content>
  <section class="feature-demo-layout">
    <h1 class="page-title">Split.IO Feature Flag Demo</h1>
    <!-- START OF FEATURE FLAG EXAMPLES -->
    <h2>Targeting Users</h2>
    <p>
      This section shows or hides features by targeting the user traffic type.
    </p>
    <div style="margin-bottom: 3rem">
      <!-- USER TARGET EXAMPLES -->
      <ion-card *appShowSplit="[demoUserTrafficTypeFlag]">
        <ion-card-header>
          <ion-card-title>Internal User Only Feature</ion-card-title>
          <ion-card-subtitle>Split.IO Integration demo</ion-card-subtitle>
        </ion-card-header>

        <ion-card-content>
          This card will be enabled for internal user accounts only.
        </ion-card-content>
      </ion-card>
    </div>

    <div style="margin-bottom: 3rem">
      <ion-card
        *appShowSplit="[demoUserTrafficTypeFlag, demoUserTrafficType3Flag]; allEnabled: false"
      >
        <ion-card-header>
          <ion-card-title
            >Internal User + 1 External User (EXTUSER01) Feature</ion-card-title
          >
          <ion-card-subtitle>Split.IO Integration demo</ion-card-subtitle>
        </ion-card-header>

        <ion-card-content>
          This card will be enabled for all internal user accounts + one
          external user (EXTUSER01)
        </ion-card-content>
      </ion-card>
    </div>

    <div style="margin-bottom: 3rem">
      <!-- ONLY EXTERNAL USERS -->
      <ion-card *appShowSplit="[demoUserTrafficType2Flag]">
        <ion-card-header>
          <ion-card-title>Only External Users</ion-card-title>
          <ion-card-subtitle>Split.IO Integration demo</ion-card-subtitle>
        </ion-card-header>

        <ion-card-content>
          This card will be enabled for internal user accounts + one external
          user
        </ion-card-content>
      </ion-card>
    </div>
    <hr />

    <!-- DIVISION TARGET EXAMPLES -->
    <h2>Targeting Divisions</h2>
    <p>
      This section shows or hides features by targeting the division traffic
      type.
    </p>
    <ion-button expand="block" *appShowSplit="[demoDivisionTrafficTypeFlag]"
      >GREEN BUTTON WILL SHOW IN DIVSION 4117</ion-button
    >
    <ion-button
      expand="block"
      *appShowSplit="[demoDivisionTrafficType2Flag]"
      [ngClass]="{'red-background': [demoDivisionTrafficType2Flag] | showSplit: false | async }"
      >RED BUTTON WILL SHOW IN DIVSION 2160</ion-button
    >

    <hr />
    <h2>Targeting Individual Customers</h2>
    <p>
      This section shows or hides features by targeting the customer traffic
      type.
    </p>
    <!-- CUSTOMER TARGET EXAMPLES -->
    <ion-button expand="block" *appShowSplit="[demoCustomerTrafficTypeFlag]"
      >GREEN BUTTON WILL SHOW FOR CUSTOMER 702738</ion-button
    >

    <div
      class="all-customers-css"
      [ngClass]="{'feature-flag-css': [demoCustomerTrafficType2Flag] | showSplit: false | async}"
    >
      <p>THIS TEXT IS DISPLAYED TO ALL CUSTOMERS.</p>
      <p>CUSTOMER <u>10946762</u> WILL SEE A BLUE BACKGROUND AND WHITE TEXT.</p>
      <p>THIS SECTION WILL BE RE-SIZABLE FOR CUSTOMER <u>10946762</u> ONLY.</p>
    </div>
  </section>
  <app-footer></app-footer>
</ion-content>
